import { Component } from '@angular/core';
import {HeroEnterpriseComponent} from "../home/hero-enterprise/hero-enterprise.component";
import {HeroServicioAmbulanciaComponent} from "./hero-servicio-ambulancia/hero-servicio-ambulancia.component";
import {InfoComponent} from "../home/info/info.component";
import {ImportantAmbulanciaComponent} from "./important-ambulancia/important-ambulancia.component";
import {FooterPersonaComponent} from "../../app-persona/footer-persona/footer-persona.component";

@Component({
  selector: 'app-servicio-ambulancia',
  standalone: true,
    imports: [
        HeroEnterpriseComponent,
        HeroServicioAmbulanciaComponent,
        InfoComponent,
        ImportantAmbulanciaComponent,
        FooterPersonaComponent
    ],
  templateUrl: './servicio-ambulancia.component.html',
  styleUrl: './servicio-ambulancia.component.css'
})
export class ServicioAmbulanciaComponent {


}
